module.exports = __webpack_public_path__ + "static/media/data-science.059f638b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/course-cards/data-science.jpg
 ** module id = 179
 ** module chunks = 0
 **/